import $ from "jquery";
import "jquery-validation/dist/jquery.validate";
import loadingButton from "../components/loadingButton";

$(document).ready(function () {
  // Boostrap: .input-group hover
  $(".input-group > input")
    .hover(function (e) {
      $(this).parent().addClass("input-group-hover");
      //$(this).parent().removeClass("input-group-focus");
    })
    .mouseout(function (e) {
      $(this).parent().removeClass("input-group-hover");
    });

  // Boostrap: .input-group focus
  $(".input-group > input")
    .focus(function (e) {
      $(this).parent().addClass("input-group-focus");
      $(this).parent().removeClass("input-group-hover");
    })
    .blur(function (e) {
      $(this).parent().removeClass("input-group-focus");
    });

  $("#bootstrap-phoenix-example-form").validate({
    rules: {
      input1: {
        required: true,
        minlength: 5,
      },
      input2: {
        required: true,
      },
      username1: {
        required: true,
        minlength: 2,
      },
      password1: {
        required: true,
        minlength: 5,
      },
      confirm_password1: {
        required: true,
        minlength: 5,
        equalTo: "#password1",
      },
      email1: {
        required: true,
        email: true,
      },
      email2: {
        required: true,
        email: true,
      },
      agree1: "required",
      addon1: "required",
      flexRadioDefault12: "required",
    },
    messages: {
      input1: {
        required: "Error message input1",
        minlength: "At least 5 characters input1",
      },
      input2: "Error message input2",
      username1: {
        required: "Please enter a username",
        minlength: "Your username must consist of at least 2 characters",
      },
      password1: {
        required: "Please provide a password",
        minlength: "Your password must be at least 5 characters long",
      },
      confirm_password1: {
        required: "Please provide a password",
        minlength: "Your password must be at least 5 characters long",
        equalTo: "Please enter the same password as above",
      },
      email1: "Please enter a valid email address",
      email2: "Please enter a valid email address",
      agree1: "Please accept our policy",
      addon1: "Please accept our addon1",
      flexRadioDefault12: "Please accept our flexRadioDefault1",
    },

    submitHandler: function (form) {
      loadingButton(form);
    },
  });
});
